module.exports = __webpack_public_path__ + "img/GARGI MA'AM.2bfb1e50.jpg";